var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sceneContainer",attrs:{"id":"scene-container"}},[_c('div',{ref:"uiContainer",attrs:{"id":"ui-container"}},[_c('Gate3dMetadata',{ref:"gateMeta",attrs:{"gateName":this.$router.currentRoute.name}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }